export default {
  name: "Español",
  pageTitles: {
    home: "Académie AETHERIS — La Claridad al Servicio de tu Soberanía",
    kit: "Kit Digital Premium — Académie AETHERIS",
    about: "Acerca de — Académie AETHERIS",
    services: "El Método — Académie AETHERIS",
    bilan: "Diagnóstico de Soberanía Gratuito — Académie AETHERIS",
    merci: "Gracias — Académie AETHERIS",
  },
  pageDescs: {
    home: "Académie AETHERIS — Revela la arquitectura secreta de tu vida. Método Triple Fusion™: Numerología, Feng Shui e IFÀ para líderes y emprendedores.",
    kit: "Kit Digital Premium — 67€: el libro «Antes de que te conviertas», los 12 Decretos Soberanos, el Cuaderno Soberano y las cuadrículas Triple Fusion™. Entrega inmediata.",
    about: "Rodrigue CASSILDÉ, Arquitecto de Vida y fundador de Académie AETHERIS. El método Triple Fusion™ nacido de 20 años de investigación y terreno.",
    services: "Descubre las ofertas de Académie AETHERIS: Diagnóstico gratuito, Kit Digital 67€, Análisis personalizados y Coaching élite Triple Fusion™.",
    bilan: "Reserva tu Diagnóstico de Soberanía GRATUITO con Académie AETHERIS. Identifica lo que bloquea tu trayectoria en 24 horas.",
    merci: "Gracias por tu pedido — descarga tus 6 herramientas Triple Fusion™.",
  },
  nav: { home: "Inicio", method: "El Método", kit: "Kit Digital", about: "Acerca de", bilan: "Evaluación Gratuita" },
  hero: {
    eyebrow: "Académie AETHERIS — Arquitectura de Vida",
    titleLines: ["La Claridad al Servicio", "de tu Soberanía."],
    sub: "Deja de sufrir tu destino. Accede a la precisión milenaria de la fusión IFÀ, Lo Shu y Pitágoras para levantar tus bloqueos y construir tu propio imperio.",
    ctaPrimary: "Solicita tu Diagnóstico de Soberanía gratuito",
    ctaSecondary: "Descubre el Método",
  },
  marquee: ["Triple Fusion™", "Numerología Vibratoria", "Feng Shui Tibetano", "Arquitectura de Vida", "Cuadrícula Lo Shu", "Soberanía Total", "Deudas Kármicas"],
  method: {
    label: "El Método Triple Fusion™",
    title: "Tres sabidurías milenarias, una trayectoria de poder.",
    quote: "PITÁGORAS decodificó los números. Lo Shu decodificó el espacio. IFÀ — Patrimonio Inmaterial de la UNESCO — decodificó el destino. La Triple Fusion™ es el primer método que une estas tres sabidurías.",
    cards: [
      { num: "01", name: "IFÀ", tag: "Memoria", title: "La memoria de tu linaje", desc: "Sabiduría ancestral reconocida como Patrimonio Inmaterial de la UNESCO. IFÀ revela las deudas del linaje y los patrones heredados que se repiten en tu vida — para desactivarlos por fin." },
      { num: "02", name: "Lo Shu", tag: "Espacio", title: "La armonía de tu entorno", desc: "La cuadrícula Lo Shu, corazón del Feng Shui tibetano, cartografía tu espacio de vida para que cada dirección trabaje a tu favor, nunca en tu contra." },
      { num: "03", name: "Pitágoras", tag: "Número", title: "La vibración de tu identidad", desc: "Tu nombre y tu fecha de nacimiento forman una firma vibratoria única. Pitágoras la decodifica para decisiones soberanas, tomadas en el momento justo." },
    ],
  },
  pathways: {
    label: "Los Caminos",
    title: "Elige el grado de tu metamorfosis.",
    offers: [
      { id: "diagnostic", name: "Diagnóstico Soberanía", price: "Gratuito", features: ["Lectura de tu matriz natal", "Identificación de tus bloqueos prioritarios", "Llamada de restitución de 30 minutos"], cta: "Reservar mi diagnóstico", to: "bilan" },
      { id: "analyse", name: "Análisis Precisión", price: "149€", features: ["Cuadrícula Lo Shu personal completa", "Informe vibratorio detallado", "Recomendaciones Feng Shui específicas"], cta: "Solicitar el análisis", to: "bilan" },
      { id: "pack", name: "Pack Renacimiento Cuántico", price: "250€", badge: "El más elegido", features: ["Incluye el Análisis Precisión completo", "Liberación de deudas kármicas", "Protocolo de reconquista 90 días"], cta: "Elegir el Renacimiento", to: "bilan" },
      { id: "elite", name: "Coaching Élite — Metamorfosis", price: "1 950€", features: ["Seguimiento individual Triple Fusion™", "Arquitectura de Vida completa", "Acceso al Círculo privado AETHERIS"], cta: "Candidatar", to: "bilan" },
    ],
  },
  kitHome: {
    label: "Kit Digital Premium",
    title: "El libro que deberían haberte entregado al nacer.",
    desc: "Un decodificador de identidad: tus patrones repetitivos, los bloqueos de tu linaje, tus ciclos numéricos — y las claves concretas para desactivarlos, uno a uno.",
    price: "67€",
    cta: "Descubrir el Kit",
  },
  founder: {
    label: "El Fundador",
    name: "Rodrigue Cassildé",
    bio: "Autoridad en Arquitectura de Vida, Numerología Vibratoria y Feng Shui Triple Fusion™. Desde hace 15 años guía a líderes, emprendedores y constructores de imperios hacia la Soberanía Total.",
    cta: "Descubre su trayectoria",
  },
  finalCta: { title: "Tu imperio comienza con un diagnóstico.", cta: "Solicita tu Diagnóstico de Soberanía gratuito" },
  kit: {
    badges: ["Entrega inmediata", "Pago seguro — Stripe", "Acceso de por vida"],
    label: "Kit Digital Premium",
    title: "Las 6 herramientas fundadoras de tu reconquista.",
    sub: "Un sistema completo — libro, decretos, cuaderno, cuadrículas y carta — para decodificar quién eres y retomar el control.",
    toolsLabel: "El Contenido",
    toolsTitle: "6 herramientas soberanas, diseñadas para ser utilizadas.",
    tools: [
      { name: "ANTES DE QUE TE CONVIERTAS", tag: "El libro fundador" },
      { name: "Los 12 Decretos Soberanos", tag: "Leyes de alineación" },
      { name: "El Cuaderno Soberano", tag: "Diario operativo — 90 días" },
      { name: "La Cuadrícula Guiada Triple Fusion™", tag: "Cartografía personal" },
      { name: "El Mapa de Direcciones Lo Shu", tag: "Brújula del espacio" },
      { name: "La Carta del Fundador", tag: "Mensaje personal de Rodrigue Cassildé" },
    ],
    bookLabel: "El Libro Fundador",
    bookTitle: "Antes de que te conviertas — el libro que deberías haber recibido al nacer.",
    bookCopy: [
      "Nadie te entregó el manual de instrucciones. Ni la escuela, ni tu familia, ni la sociedad. Aprendiste a funcionar — nunca a decodificarte.",
      "Este libro es un decodificador de identidad. Cruza la sabiduría de IFÀ, la cuadrícula Lo Shu y los números de Pitágoras para revelarte lo que siempre estuvo escrito: tus ciclos, tus bloqueos, tus líneas de fuerza.",
    ],
    bullets: [
      "Tus patrones repetitivos — y por qué siempre vuelven",
      "Los bloqueos de tu linaje — y cómo desactivarlos",
      "Tus ciclos numéricos personales — para decidir en el momento justo",
      "Tu cartografía Triple Fusion™ — tu punto de partida soberano",
    ],
    ctaTitle: "Tu reconquista comienza ahora.",
    ctaSub: "Una inversión única de 67€ para recibir las 6 herramientas fundadoras del método Triple Fusion™.",
    buy: "Pido mi Kit — 67€",
    note: "Entrega por email inmediatamente después del pago.",
    afterLink: "¿Ya lo pediste? Accede a tus descargas",
  },
  about: {
    label: "Acerca de",
    title: "El arquitecto detrás del método.",
    bioLabel: "El Fundador",
    bio: [
      "Rodrigue Cassildé — autoridad en Arquitectura de Vida, Numerología Vibratoria y Feng Shui Triple Fusion™.",
      "Desde hace 15 años guía a líderes, emprendedores y constructores de imperios hacia la Soberanía Total. Su convicción: nadie debería sufrir un destino que no ha decodificado.",
      "Académie AETHERIS nació de esa convicción — una casa donde tres sabidurías milenarias se convierten en una sola trayectoria de poder.",
    ],
    quote: "PITÁGORAS decodificó los números. Lo Shu decodificó el espacio. IFÀ — Patrimonio Inmaterial de la UNESCO — decodificó el destino. La Triple Fusion™ es el primer método que une estas tres sabidurías.",
    valuesLabel: "Valores Cardinales",
    valuesTitle: "Lo que nunca se negocia.",
    values: [
      { num: "01", name: "Excelencia", desc: "Sin compromiso. Cada análisis, cada protocolo, cada palabra se entrega con la misma exigencia — tu trayectoria merece lo mejor de las tres sabidurías." },
      { num: "02", name: "Soberanía", desc: "Dueño de tu destino. No creamos dependencia: transmitimos las claves para que nunca más sufras." },
      { num: "03", name: "Discreción", desc: "Élite, confidencial. Tu matriz, tus bloqueos, tus decisiones — todo lo que se dice aquí, aquí se queda." },
    ],
    legalLabel: "Estructura Legal",
    legal: "Académie AETHERIS opera bajo Synergie VITA Holding (SVH), SAS con capital de 500€, inscrita en el RCS Fort-de-France con el SIREN 108849241.",
    ctaTitle: "¿Listo para conocer tu matriz?",
    cta: "Solicita tu Diagnóstico de Soberanía gratuito",
  },
  services: {
    label: "Nuestros Servicios",
    title: "Un camino para cada grado de Soberanía.",
    sub: "Del primer diagnóstico a la mentoría de élite, cada camino es un peldaño. Elige el tuyo.",
    offers: [
      { id: "diagnostic", name: "Diagnóstico Soberanía", price: "Gratuito", desc: "El punto de partida. 30 minutos para leer tu matriz y nombrar lo que te bloquea.", features: ["Lectura de tu matriz natal", "Identificación de tus bloqueos prioritarios", "Llamada de restitución de 30 minutos"], cta: "Reservar mi diagnóstico", to: "bilan" },
      { id: "kit", name: "Kit Digital Premium", price: "67€", desc: "Las 6 herramientas fundadoras del método Triple Fusion™, entregadas de inmediato.", features: ["El libro «Antes de que te conviertas»", "Los 12 Decretos Soberanos", "El Cuaderno Soberano — 90 días", "La Cuadrícula Guiada Triple Fusion™"], cta: "Pedir el Kit", to: "kit" },
      { id: "analyse", name: "Análisis Precisión", price: "149€", desc: "Tu cartografía vibratoria completa.", features: ["Cuadrícula Lo Shu personal completa", "Informe vibratorio detallado", "Recomendaciones Feng Shui específicas"], cta: "Solicitar el análisis", to: "bilan" },
      { id: "pack", name: "Pack Renacimiento Cuántico", price: "250€", badge: "El más elegido", desc: "El análisis, la liberación, el protocolo.", features: ["Incluye el Análisis Precisión completo", "Liberación de deudas kármicas", "Protocolo de reconquista 90 días"], cta: "Elegir el Renacimiento", to: "bilan" },
      { id: "elite", name: "Coaching Élite — Metamorfosis", price: "1 950€", desc: "Tres meses de mentoría privada con Rodrigue Cassildé.", features: ["Seguimiento individual Triple Fusion™", "Arquitectura de Vida completa", "Acceso al Círculo privado AETHERIS"], cta: "Candidatar", to: "bilan" },
    ],
  },
  bilan: {
    label: "Diagnóstico de Soberanía Gratuito — 30 minutos",
    title: "¿Sientes que algo bloquea tu vida — sin saber qué?",
    sub: "En 30 minutos, leemos tu matriz, identificamos tus bloqueos prioritarios y te entregamos un plan de acción concreto. Sin compromiso.",
    benefitsLabel: "Con qué te vas",
    benefits: [
      "Una lectura clara de tu matriz natal",
      "La identificación de tus bloqueos prioritarios",
      "Tus primeras direcciones Lo Shu",
      "Un plan de acción concreto e inmediato",
    ],
    testimonialsLabel: "Ellos dieron el paso",
    testimonials: [
      { text: "En una sola llamada, Rodrigue nombró lo que tres años de terapia apenas habían rozado. Mi protocolo de 90 días lo cambió todo.", name: "Claire M.", role: "Empresaria" },
      { text: "El Análisis Precisión me leyó como un libro abierto. Por fin entendí por qué los mismos patrones volvían — y cómo terminarlos.", name: "Julien R.", role: "Directivo" },
      { text: "Era escéptica. Luego la cuadrícula Lo Shu explicó mi casa, mis decisiones, mis bloqueos. Nada volvió a ser igual.", name: "Sofia D.", role: "Fundadora" },
    ],
    form: {
      title: "Reserva tu espacio",
      firstNames: "Nombres",
      lastName: "Apellido",
      maidenName: "Apellido de soltera (opcional)",
      birthDate: "Fecha de nacimiento",
      sex: "Sexo",
      female: "Mujer",
      male: "Hombre",
      email: "Email",
      submit: "Solicitar mi Diagnóstico gratuito",
      sending: "Enviando…",
      success: "Tu solicitud ha sido recibida. Rodrigue te contactará en 24 horas. Mientras tanto, también puedes reservar directamente un espacio:",
      calendlyButton: "Reservar mi llamada de seguimiento (30 min)",
      error: "Algo salió mal. Inténtalo de nuevo en un instante.",
    },
    quote: { text: "No estás bloqueado. Simplemente estás funcionando con el manual de instrucciones equivocado.", author: "Rodrigue Cassildé" },
  },
  merci: {
    label: "Pedido Confirmado",
    title: "Tu Kit está en camino.",
    sub: "Tus 6 herramientas están en camino a tu bandeja de entrada. También puedes descargarlas inmediatamente abajo.",
    frOnlyNote: "",
    downloadsLabel: "Tus descargas",
    note: "Guarda estos enlaces — acceso de por vida.",
    backHome: "Volver al inicio",
  },
  footer: {
    tagline: "Arquitectura de Vida — IFÀ ◆ Lo Shu ◆ Pitágoras",
    navTitle: "Navegación",
    langTitle: "Idioma",
    svh: "Académie AETHERIS — Synergie VITA Holding (SVH), SAS con capital de 500€ — RCS Fort-de-France — SIREN 108849241",
    rights: "© 2026 Académie AETHERIS. Todos los derechos reservados.",
  },
};
